export default __webpack_public_path__ + "images/product/skin_types/normal_to_dry-c6f48b99cf79167c7473423f93c8596d.svg";